import { Component, OnInit } from '@angular/core';

import { PPAuthService } from '../../core/services/auth.service';
import { User } from '../../core/models/user.model';
import { Observable, Subscription, SubscriptionLike as ISubscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.page.html',
  styleUrls: ['./personal-data.page.scss'],
})
export class PersonalDataPage implements OnInit {

  me$: Observable<User>;

  constructor( private authService: PPAuthService, private router: Router ) {
    this.me$ = this.authService.me2$;
  }

  ngOnInit() {
  }

}
